module.exports = __webpack_public_path__ + "static/media/Chapter11.c75e702c.pdf";